import React, { FC, useState } from "react";
import {
  IonButton,
  IonSpinner,
  IonSelectOption,
  IonSelect
} from "@ionic/react";

interface IProps {
    handleRequest:(month:number,year:number)=>void
    loading:boolean
};

const MonthYearRequestBtn:FC<IProps> = ({handleRequest,loading}) => {
    const today = new Date();
    today.setMonth(today.getMonth() - 1);
    const [month, setMonth] = useState(today.getMonth() + 1);
    const [year, setYear] = useState(today.getFullYear());
    const yr = new Date().getFullYear();
    const years = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

    return <div>
        <div style={{ width: "100%", textAlign: "center", padding: "1rem" }}>
                          Enter Month and Year to Generate and Download Report.
                        </div>
                        {/* <IonDatetime presentation="month-year"></IonDatetime> */}
                        <div>
                          <IonSelect
                            label="Month"
                            interface="popover"
                            value={month}
                            placeholder="Month"
                            onIonChange={(e) => {
                              setMonth(e.detail.value!);
                            }}
                          >
                            <IonSelectOption value={1}>1 - January</IonSelectOption>
                            <IonSelectOption value={2}>2 - February</IonSelectOption>
                            <IonSelectOption value={3}>3 - March</IonSelectOption>
                            <IonSelectOption value={4}>4 - April</IonSelectOption>
                            <IonSelectOption value={5}>5 - May</IonSelectOption>
                            <IonSelectOption value={6}>6 - June</IonSelectOption>
                            <IonSelectOption value={7}>7 - July</IonSelectOption>
                            <IonSelectOption value={8}>8 - August</IonSelectOption>
                            <IonSelectOption value={9}>9 - September</IonSelectOption>
                            <IonSelectOption value={10}>10 - October</IonSelectOption>
                            <IonSelectOption value={11}>11 - November</IonSelectOption>
                            <IonSelectOption value={12}>12 - December</IonSelectOption>
                          </IonSelect>
                          <IonSelect
                            label="Year"
                            interface="popover"
                            placeholder="Year"
                            value={year}
                            onIonChange={(e) => {
                              setYear(e.detail.value!);
                            }}
                          >
                            {years.map((i: number) => (
                              <IonSelectOption key={i} value={yr - i}>
                                {yr - i}
                              </IonSelectOption>
                            ))}
                          </IonSelect>
                        </div>
              <IonButton
                fill="solid"
                color="primary"
                size="small"
                expand="block"
                onClick={() => handleRequest(month,year)}
                >
                  {loading ? <IonSpinner /> : "Download"}
              </IonButton>
    </div>
};

export default MonthYearRequestBtn;